import React from 'react';
import {
    List, Datagrid, TextField, NumberField, Filter, TextInput, EditButton,
} from 'react-admin';

import SupplyCategoryInput from '../controls/SupplyCategoryInput';
import BoolNumField from '../controls/BoolNumField';
import { SOFT_GOODS_BY_FIELD } from '../controls/softGoods';
import ErrorBoundary from '../ErrorBoundary';

/** Which Phlebotomy tab lot box this type's lots show up in, if any. */
const PhleboFieldField = ({ record }) => {
    if (!record || !record.phlebo_field) { return <span>-</span>; }
    const spec = SOFT_GOODS_BY_FIELD[record.phlebo_field];
    return <span>{spec ? spec.label : record.phlebo_field}</span>;
};

PhleboFieldField.defaultProps = { label: 'Phlebotomy Lot Field', source: 'phlebo_field' };

const SupplyTypeFilters = props => (
    <Filter {...props}>
        <TextInput source="name" label="Name" alwaysOn />
        <SupplyCategoryInput alwaysOn allowEmpty />
    </Filter>
);

const SupplyTypeList = props => (
    <ErrorBoundary>
        <List
            {...props}
            title="Supply Types"
            filters={<SupplyTypeFilters />}
            perPage={25}
            sort={{ field: 'name', order: 'ASC' }}
            bulkActionButtons={false}
            exporter={false}
        >
            <Datagrid>
                <TextField source="name" label="Name" />
                <TextField source="category" label="Category" />
                <TextField source="code" label="Code" />
                <TextField source="uom" label="UOM" />
                <BoolNumField source="requires_qa" label="QA Required?" />
                <BoolNumField source="has_sublots" label="Sublots?" />
                <PhleboFieldField />
                <NumberField source="reorder_point" label="Reorder Point" />
                <NumberField source="expiry_warn_days" label="Expiry Warn (days)" />
                <BoolNumField source="status" label="Is Active?" />
                <EditButton />
            </Datagrid>
        </List>
    </ErrorBoundary>
);

export default SupplyTypeList;
